import React, { useMemo } from "react";
import { useOrganization } from "../../context/OrganizationContext";
import { resolveOrgBranding } from "../../helpers/resolveOrgBranding";

export function ReportPrintFooter({ generatedDate, branding: brandingOverride }) {
  const { settings } = useOrganization();
  const branding = useMemo(
    () => brandingOverride ?? resolveOrgBranding(settings),
    [brandingOverride, settings],
  );

  return (
    <footer className="erp-footer">
      <span>{branding.footerText}</span>
      <span>{generatedDate || ""}</span>
    </footer>
  );
}
